var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var ChartLinechart = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 1024 832", width: "1em", height: "1em" }, props),
    React.createElement("defs", null),
    React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
        React.createElement("g", { id: "icon" },
            React.createElement("path", { className: "cls-1", d: "M992 768H96a32 32 0 0 1-32-32V32a32 32 0 0 0-64 0v704a96.11 96.11 0 0 0 96 96h896a32 32 0 0 0 0-64z" }),
            React.createElement("path", { className: "cls-1", d: "M192.43 639.57a31.9 31.9 0 0 0 22.63-9.37l201.37-201.37 82.32 82.31a64 64 0 0 0 90.5 0l233.38-233.37c.28-.29.56-.58.83-.88L870 323.4a32 32 0 0 0 54-16.4l34.55-172.76a32 32 0 0 0-37.65-37.66l-172.8 34.6a32 32 0 0 0-16.35 54l46.5 46.5c-.29.28-.59.55-.88.84L544 465.89l-82.32-82.32a64.08 64.08 0 0 0-90.51 0L169.8 584.94a32 32 0 0 0 22.63 54.63zm693.92-470.78l-13.41 67.07-53.66-53.65z" }))))); };
export default ChartLinechart;
//# sourceMappingURL=ChartLinechart.js.map